import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async"; // Corrected import for meta tags
import NavBar from "../Navigation/NavBar";
import Benner from "./Benner";
import Services from "./Services/Services";
import Industrie from "./Industrie/Industrie";
import WhyChoose from "./WhyChoose/WhyChoose";
import ClientsAndCandidates from "./ClientsAndCandidates/ClientsAndCandidates";
import OurProcess from "./OurProcess/OurProcess";
import GetInTouch from "../GetInTouch/GetInTouch";
import Footer from "../Footer/Footer";
import WhatsAppWidgetComponent from "../Whatsapp/WhatsAppWidgetComponent";
import { Link } from "react-router-dom";

function Home() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      {/* Use Helmet for meta tags in React */}
      <Helmet>
        <meta name="keywords" content="HR solutions, placement services, recruitment, Quarec Resources" />
        <meta name="author" content="Quarec Resources" />
      </Helmet>

      <NavBar />
      <Benner />
      <Services />
      <Industrie />
      <WhyChoose />
      <ClientsAndCandidates />
      <OurProcess />
      <section style={{padding:'50px 20px',background:'#f4faf8',textAlign:'center'}} aria-label="Free recruitment resources">
        <div style={{maxWidth:920,margin:'auto'}}>
          <h2 style={{fontSize:'clamp(24px,3vw,36px)',fontWeight:800}}>Practical hiring and career tools</h2>
          <p style={{fontSize:17,lineHeight:1.75}}>Create a clear job brief, use a fairer interview worksheet, or review an offer before accepting it. Our tools are free and run locally in your browser.</p>
          <Link to="/Resources" style={{display:'inline-block',background:'#098577',color:'white',padding:'13px 25px',borderRadius:9,textDecoration:'none',fontWeight:700}}>Explore free resources →</Link>
        </div>
      </section>
      <GetInTouch />
      <Footer />
      <WhatsAppWidgetComponent />
    </>
  );
}

export default Home;
